export default __webpack_public_path__ + "static/media/2728 utensils top.94aa23d6.png";